"use client";

import { useEffect } from "react";
import { event } from "@/lib/gtag";

/**
 * Fires a GA4 `page_not_found` event once on mount.
 * Intended to be dropped into `app/not-found.tsx` without
 * forcing the whole page to become a client component.
 */
export default function NotFoundEvent() {
  useEffect(() => {
    event("page_not_found", { page_path: window.location.pathname });
  }, []);

  return null;
}
